import { combineReducers } from "redux";
import footerMenuReducer from "./src/FooterMenu/reducer";
import testReducer from "./src/test/reducer";
import userReducer from "./src/containers/RegistrationForm/reducer";
import loginReducer from "./src/containers/LogIn/reducer";
import forgotPasswordReducer from "./src/containers/ForgotPassword/reducer";
import agreementReducer from "./src/containers/Agreement/reducer";
import privacyReducer from "./src/containers/Privacy/reducer";
import cookiesReducer from "./src/containers/Cookies/reducer";
import spinnerReducer from "./src/containers/Spinner/reducer";
import yourNameMessageContactReducer from "./src/containers/Contact/reducer";
import colorTheoryReducer from "./src/containers/KnowladgeColorTheory/reducer";
import whatIsLoriiniTestReducer from "./src/containers/KnowladgeWhatIsLoriiniTest/reducer";
import howInterprateResultReducer from "./src/containers/KnowladgeHowInterprateResult/reducer";
import knowladgeEffectiveCommunicationReducer from "./src/containers/KnowladgeEffectiveCommunication/reducer";
import knowladgeWaysOfCommunicationReducer from "./src/containers/KnowladgeWaysOfCommunication/reducer";
import knowladgeManipulationReducer from "./src/containers/KnowladgeManipulation/reducer";
import languageReducer from "./src/containers/Language/reducer";

export default combineReducers({
  test: testReducer,
  activeFotterMenu: footerMenuReducer,
  login: loginReducer,
  user: userReducer,
  errorMessages: forgotPasswordReducer,
  agreement: agreementReducer,
  privacy: privacyReducer,
  cookies: cookiesReducer,
  spinner: spinnerReducer,
  errorContactMessages: yourNameMessageContactReducer,
  colorTheory: colorTheoryReducer,
  whatIsLoriiniTest: whatIsLoriiniTestReducer,
  howInterprateResult: howInterprateResultReducer,
  effectiveCommunication: knowladgeEffectiveCommunicationReducer,
  waysOfCommunication: knowladgeWaysOfCommunicationReducer,
  manipulation: knowladgeManipulationReducer,
  language: languageReducer,
});
